<template>
  <div
    id="divContainer"
    v-show="getAdvExpoflag == false"
    v-on:click="exitmenu"
    class="page-effect"
  >
    <!-- <TopMenu /> -->
    <section
      @click="onClickHandler"
      id="sectionId"
      class="sponsors-list-wrapper d-flex body-content"
      onmouseover="exitmenu();"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >
      <div class="container-fluid left-right-common-gap">
        <div class="row new-addendee-list bg-transparent">
          <div class="col-md-6">
            <h1 id="headerText" class="page-head text-uppercase">
              {{ headerText }}
            </h1>
          </div>
          <div class="col-md-6">
            <div class="row justify-content-end">
              <div class="col-md-8 mb-3 mb-md-0 pr-1">
                <div class="position-relative fixed-w full-width search-hld">
                  <form
                    id="newsletter-validate-detail"
                    class="form subscribe"
                    action
                    method
                  >
                    <!-- <input
                      id="InputSearch"
                      type="text"
                      @keyup="searchExhibitor"
                      v-model="searchtext"
                      placeholder="Search by Name or Keywords...  "
                    />-->
                    <input
                      id="InputSearch"
                      type="text"
                      @keyup="searchExhibitor2"
                      v-on:keydown.enter.prevent="searchExhibitor"
                      v-model="searchtext"
                      placeholder="Type & hit Enter to Search by Name or Keywords...  "
                    />
                  </form>
                </div>
              </div>
              <!---filter box----->
              <div class="col-md-4 mb-3 mb-md-0 pl-1">
                <div class="position-relative fixed-w full-width filter-hld">
                  <select v-on:change="displayEshibitor" id="selFilter">
                    <option
                      v-bind:key="item.id"
                      :id="item.id"
                      v-for="item in DropFilter"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </div>
              </div>
              <!-------->
            </div>
          </div>
        </div>
        <div class="row" id="divExhibitor">
          <div
            v-for="Exhibitor in ExhibitorData"
            v-bind:key="Exhibitor.id"
            class="col-lg-2 col-md-6 filterPanel"
            id="161290"
            title="Management Consulting"
          >
            <div class="sponsors-box-hld text-center">
              <router-link
                class="tab-link"
                data-tag="exhibitorDetailsLink"
                v-bind:to="{
                  name: 'ExhibitorDetails',
                  params: { sid: Exhibitor.id },
                }"
              >
                <input
                  id="SponsorName"
                  type="hidden"
                  value="Management Consulting"
                />
                <span class="logo-area">
                  <img
                    v-bind:src="Exhibitor.Logo"
                    v-bind:alt="Exhibitor.Name"
                  />
                </span>
                <div class="grey-bg-texthld">
                  <h3>{{ Exhibitor.Name }}</h3>
                  <p>Booth {{ Exhibitor.BoothNo }}</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div
          id="divLoading"
          style="
            margin: 0px;
            padding: 0px;
            position: fixed;
            right: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            z-index: 30001;
            opacity: 1;
            transform: scale(2);
            display: none;
          "
        >
          <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
          <div class="loader">
            <svg
              width="65px"
              height="65px"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  values="0 33 33;270 33 33"
                  begin="0s"
                  dur="1.4s"
                  fill="freeze"
                  repeatCount="indefinite"
                />
                <circle
                  fill="none"
                  stroke-width="6"
                  stroke-linecap="round"
                  cx="33"
                  cy="33"
                  r="30"
                  stroke-dasharray="187"
                  stroke-dashoffset="610"
                >
                  <animate
                    attributeName="stroke"
                    values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                    begin="0s"
                    dur="5.6s"
                    fill="freeze"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    values="0 33 33;135 33 33;450 33 33"
                    begin="0s"
                    dur="1.4s"
                    fill="freeze"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="stroke-dashoffset"
                    values="187;46.75;187"
                    begin="0s"
                    dur="1.4s"
                    fill="freeze"
                    repeatCount="indefinite"
                  />
                </circle>
              </g>
            </svg>
          </div>
          <!-- </p> -->
        </div>
        <!-- No dat Found -->
        <div v-show="IsShowNoDataFound" style="text-align: center">
          <h2 style="text-align: center; margin-top: 60px">No Data found.</h2>
          <!-- <button
            id="btnNewSearch"
            v-on:click="cancelSearch()"
            class="blue-button"
            type="button"
            style="text-align:center;margin-top: 60px;"
            data-tag="attendeeNewSearch"
          >Start new search</button>-->
        </div>

        <!-- No dat Found ENDS-->
      </div>
    </section>
  </div>
</template>

<script>
import jQuery from "jquery";
let $ = jQuery;
// @ is an alias to /src
//import TopMenu from "@/components/TopMenu.vue";
import db from "../components/firebaseInit";
import analytics from "@/components/Analytics";
import router from "../router";
import store from "../store";
import axios from "axios";

let lastVisible = null;
let hasMore = true;
var self = "";
export default {
  data() {
    return {
      headerText: this.$t("expo.oldTitle"),
      searchtext: "",
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      lastVisible: null,
      ExhibitorData: [],
      DropFilter: [],
      clientID: this.$store.getters.getClient[0].id,
      eventId: "",
      IsSearchMode: false,
      IsShowNoDataFound: false,
      filtertext: "",
    };
  },
  components: {
    //TopMenu
  },

  methods: {
    displayEshibitor() {
      //------search start--------------------------------------------------------------
      if (this.searchtext.trim() != "") {
        // alert("search");

        self.IsSearchMode = true;

        //----------------------------------------------------------------------------------------
        var hostUrl = location.host.toLowerCase();
        var searchUrl = "";
        if (hostUrl.includes("localhost")) {
          searchUrl =
            "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchexhibitors/" +
            this.searchtext;
        } else {
          if (hostUrl.includes("uat")) {
            searchUrl =
              "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchexhibitors/" +
              this.searchtext;
          } else {
            searchUrl =
              "https://us-central1-e2monair.cloudfunctions.net/app/api/searchexhibitors/" +
              this.searchtext;
          }
        }
        //----------------------------------------------------------------------------------------------------

        console.log(this.clientID);
        this.eventId = this.getEventID();
        console.log(this.eventId);

        //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        self.ExhibitorData = [];
        let headers = {
          apikey: "ws2000rb28082019",
          InstancePrefix: "OA",
          clientID: this.clientID, // "C1591205467009",
          Env: "UAT",
          eventID: this.eventId, //"E1591206650065",
          "content-type": "application/json",
        };
        self.showLoader();
        axios
          .get(searchUrl, false, {
            headers: headers,
          })
          .then((responseData) => {
            let data = responseData.data;
            self.ExhibitorData = [];
            self.hideLoader();
            // console.log(data);
            for (var i = 0; i < data.length; i++) {
              var filteredRows = self.ExhibitorData.filter(function (value) {
                return (
                  value.id ==
                  (data[i].ExhibitorId != undefined ? data[i].ExhibitorId : "")
                );
              });
              if (filteredRows.length == 0) {
                self.ExhibitorData.push({
                  id:
                    data[i].ExhibitorId != undefined
                      ? data[i].ExhibitorId
                      : "0",
                  Name: data[i].Name != undefined ? data[i].Name : "",
                  Logo: data[i].Logo != undefined ? data[i].Logo : "",
                  Email: data[i].Email != undefined ? data[i].Email : "",
                  Category:
                    data[i].Category != undefined ? data[i].Category : "",
                  BoothNo: data[i].BoothNo != undefined ? data[i].BoothNo : "",
                });

                // debugger;
              }
            }

            console.log(self.ExhibitorData);
            if (self.ExhibitorData.length > 0) {
              self.IsShowNoDataFound = false;
            } else {
              self.IsShowNoDataFound = true;
            }
          })
          .catch((error) => {
            console.log(error);
            self.hideLoader();
            debugger;
            this.IsShowNoDataFound = true;
          });

        //$.ajax({
        //  url: searchUrl,
        //  headers: {
        //    "Content-Type": "application/json",
        //    apikey: "ws2000rb28082019",
        //    InstancePrefix: "OA",
        //    clientID: this.clientID, // "C1591205467009",
        //    Env: "UAT",
        //    eventID: this.eventId, //"E1591206650065",
        //  },
        //  beforeSend: function () {
        //    self.showLoader();
        //  },
        //  type: "GET",
        //  // mode: 'cors',
        //  //credentials: "include",
        //  crossDomain: true,
        //  dataType: "json",
        //  processData: false,
        //  //   data: JSON.stringify(postData),

        //  success: function (data) {
        //    self.ExhibitorData = [];
        //    self.hideLoader();
        //    // console.log(data);
        //    for (var i = 0; i < data.length; i++) {
        //      var filteredRows = self.ExhibitorData.filter(function (value) {
        //        return (
        //          value.id ==
        //          (data[i].ExhibitorId != undefined ? data[i].ExhibitorId : "")
        //        );
        //      });
        //      if (filteredRows.length == 0) {
        //        self.ExhibitorData.push({
        //          id:
        //            data[i].ExhibitorId != undefined
        //              ? data[i].ExhibitorId
        //              : "0",
        //          Name: data[i].Name != undefined ? data[i].Name : "",
        //          Logo: data[i].Logo != undefined ? data[i].Logo : "",
        //          Email: data[i].Email != undefined ? data[i].Email : "",
        //          Category:
        //            data[i].Category != undefined ? data[i].Category : "",
        //          BoothNo: data[i].BoothNo != undefined ? data[i].BoothNo : "",
        //        });

        //        // debugger;
        //      }
        //    }

        //    console.log(self.ExhibitorData);
        //    if (self.ExhibitorData.length > 0) {
        //      self.IsShowNoDataFound = false;
        //    } else {
        //      self.IsShowNoDataFound = true;
        //    }
        //  },
        //  error: function () {
        //    console.log("error");
        //    self.hideLoader();
        //    debugger;
        //    this.IsShowNoDataFound = true;
        //    return false;
        //  },
        //});
        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        lastVisible = null;
        hasMore = true;
      }
      //------------search end--------------------------------------------------------
      else {
        //alert("without search");
        debugger;
        self.IsShowNoDataFound = false;
        if (!hasMore) {
          return;
        }
        //alert("hasMore" + hasMore);
        //
        this.pageIndex++;
        self.IsSearchMode = false;
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        console.log("EventColName : " + obj.eventcollectionname);
        //------------------------------------------------------------------------------------------
        self.filterText = $("#selFilter option:selected").text();

        console.log(self.filterText);
        var listRef;
        if (self.filterText != "") {
          if (self.filterText != "All") {
            hasMore = true;
            self.ExhibitorData = [];
            listRef = db
              .collection(obj.eventcollectionname)
              .doc("ExhibitorList")
              .collection("Exhibitors")
              .where("Category", "==", self.filterText)
              .where("IsPublished", "==", true);

            //======================================================================

            listRef
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  var filteredRows = self.ExhibitorData.filter(function (
                    value
                  ) {
                    return value.id == doc.id;
                  });
                  debugger;
                  if (filteredRows.length == 0) {
                    self.ExhibitorData.push({
                      id: doc.id,
                      Name: doc.data().Name,
                      Logo: doc.data().Logo,
                      Email: doc.data().Email,
                      Category: doc.data().Category,
                      BoothNo: doc.data().BoothNo,
                    });
                  }
                });
              })
              .catch((error) => {
                alert(error);
                // console.log("Error getting documents: ", error);
              });
            //==============================================================================
          } else {
            listRef = db
              .collection(obj.eventcollectionname)
              .doc("ExhibitorList")
              .collection("Exhibitors")
              .where("IsPublished", "==", true);
            //======================================================================

            if (lastVisible == null) {
              listRef = listRef.limit(this.pageSize);
            } else {
              listRef = listRef.startAfter(lastVisible).limit(this.pageSize);
            }

            listRef
              .get()
              .then((querySnapshot) => {
                hasMore = querySnapshot.docs.length > 0;
                if (hasMore) {
                  lastVisible =
                    querySnapshot.docs[querySnapshot.docs.length - 1];
                  querySnapshot.forEach((doc) => {
                    var filteredRows = self.ExhibitorData.filter(function (
                      value
                    ) {
                      return value.id == doc.id;
                    });
                    debugger;
                    if (filteredRows.length == 0) {
                      self.ExhibitorData.push({
                        id: doc.id,
                        Name: doc.data().Name,
                        Logo: doc.data().Logo,
                        Email: doc.data().Email,
                        Category: doc.data().Category,
                        BoothNo: doc.data().BoothNo,
                      });
                    }
                  });
                }
              })
              .catch((error) => {
                alert(error);
                // console.log("Error getting documents: ", error);
              });
            //==============================================================================
          }
          hasMore = true;
          lastVisible = null;
        } else {
          //======================================================================
          listRef = db
            .collection(obj.eventcollectionname)
            .doc("ExhibitorList")
            .collection("Exhibitors")
            .where("IsPublished", "==", true);
          //--------------------------------------------------------------------------------------------

          if (lastVisible == null) {
            listRef = listRef.limit(this.pageSize);
          } else {
            listRef = listRef.startAfter(lastVisible).limit(this.pageSize);
          }

          listRef
            .get()
            .then((querySnapshot) => {
              hasMore = querySnapshot.docs.length > 0;
              if (hasMore) {
                lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
                querySnapshot.forEach((doc) => {
                  var filteredRows = self.ExhibitorData.filter(function (
                    value
                  ) {
                    return value.id == doc.id;
                  });
                  debugger;
                  if (filteredRows.length == 0) {
                    self.ExhibitorData.push({
                      id: doc.id,
                      Name: doc.data().Name,
                      Logo: doc.data().Logo,
                      Email: doc.data().Email,
                      Category: doc.data().Category,
                      BoothNo: doc.data().BoothNo,
                    });
                  }
                });
              }
            })
            .catch((error) => {
              alert(error);
              // console.log("Error getting documents: ", error);
            });
          //==============================================================================
        }

        //----------without search-----------------------------------------------------------------------------------------
      }
    },
    getfilters() {
      this.DropFilter = [];
      // this.DropFilter.push({ id: "All", value: "All" });
      // this.DropFilter.push({ id: "General", value: "General" });
      // this.DropFilter.push({ id: "Platinum", value: "Platinum" });
      // this.DropFilter.push({ id: "Gold", value: "Gold" });
      // this.DropFilter.push({ id: "Silver", value: "Silver" });
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      this.DropFilter.push({ id: "All", value: "All" });
      var docref = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorCategories")
        .collection("Category");

      docref
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.DropFilter.push({ id: doc.id, value: doc.id });
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    getEventID() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventid;
    },
    searchExhibitor2: function () {
      if (self.searchtext == "") {
        $("#divExhibitor").html("");
        self.totalRecords = 1;
        self.firstPageCalled = false;
        self.pageIndex = 0;
        self.hasMore = true;
        lastVisible = null;
        self.ExhibitorData = [];
        self.displayEshibitor();
      }
    },
    searchExhibitor: function () {
      $("#divExhibitor").html("");
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.hasMore = true;
      lastVisible = null;
      self.ExhibitorData = [];
      self.displayEshibitor();
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },

    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    scroll: function () {
      window.onscroll = () => {
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            if (self.searchtext.trim() == "") {
              this.displayEshibitor();
            }
            this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    ExpoClick: function () {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                debugger;
                if (doc.data().EnableEnhancedExpoMode === true) {
                  $("#liexhibitor")
                    .find("a:first")
                    .addClass("router-link-exact-active router-link-active");
                  router.push("/exhibitorshall");
                  store.commit("setAdvExpo", true);
                } else {
                  store.commit("setAdvExpo", false);
                  $(".page-effect").show();
                }
              });
            })
            .catch((error) => {
              alert(error);
            });
        }
      }
    },
  },
  beforeDestroy() {
    // self.IsSearchMode = false;
    this.lastVisible = null;
    self.Exhibitorlist = [];
    self.filterText = "";
    self.DropFilter = [];

    self.searchtext = "";
  },
  async mounted() {
    self = this;
    this.getfilters();
    this.ExpoClick();
    self.ExhibitorData = [];
    $("#topmenu").show();
    $("#leftmenu").show();
    $("#btnAddUserView").click();
    this.displayEshibitor();
    this.scroll();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        debugger;
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }

    //-------------dynamic font selection --------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------
    debugger;
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );
    //this.filterDropdown();
    //-------Page Title-------------
    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              debugger;
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                self.headerText = value.DisplayLabel_es;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              debugger;
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                self.headerText = value.DisplayLabel_es;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        document.title = self.headerText + " - " + obj.eventname;
      });

    document.title = self.headerText + " - " + obj.eventname;

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black";
          }
        } else {
          self.textColor = "black";
        }
        console.log("BodyTextColor :- " + self.textColor);
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }
  },
  computed: {
    getAdvExpoflag() {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.advExpo;
    },
  },
};
</script>

<style>
/* === Modern Exhibits header redesign — unified dark pill === */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

.sponsors-list-wrapper,
.sponsors-list-wrapper * {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
}

.sponsors-list-wrapper .page-head {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700 !important;
  letter-spacing: 0.6px;
  color: #ffffff;
}

@media (min-width: 768px) {
  /* Merge the two columns into one pill */
  .sponsors-list-wrapper .new-addendee-list > .col-md-6:last-child > .row {
    background: rgba(0, 0, 0, 0.55);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    border-radius: 999px;
    padding: 4px 6px;
    align-items: center;
    flex-wrap: nowrap;
    margin: 0 0 0 auto;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
    max-width: 100%;
  }

  .sponsors-list-wrapper .new-addendee-list .col-md-8,
  .sponsors-list-wrapper .new-addendee-list .col-md-4 {
    margin: 0 !important;
    padding: 0 !important;
    flex: 0 0 auto;
    max-width: none;
  }

  /* Filter dropdown moves to the left side of the pill */
  .sponsors-list-wrapper .new-addendee-list .col-md-4 {
    order: -1;
    width: 110px;
    border-right: 1px solid rgba(255, 255, 255, 0.18);
  }

  .sponsors-list-wrapper .new-addendee-list .col-md-8 {
    flex: 1 1 auto;
    min-width: 260px;
  }
}

/* Filter dropdown styling */
.sponsors-list-wrapper .filter-hld {
  width: 100% !important;
  margin: 0 !important;
}

.sponsors-list-wrapper .filter-hld select#selFilter {
  background-color: transparent !important;
  border: none !important;
  color: #ffffff !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 0 32px 0 18px !important;
  height: 38px !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='%23ffffff' d='M6 8L0 0h12z'/></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  box-shadow: none !important;
  cursor: pointer;
  outline: none;
}

.sponsors-list-wrapper .filter-hld select#selFilter option {
  background: #1a1a1a;
  color: #ffffff;
  font-family: "Poppins", sans-serif;
}

/* Search input styling */
.sponsors-list-wrapper .search-hld {
  width: 100% !important;
  margin: 0 !important;
}

.sponsors-list-wrapper .search-hld form.subscribe {
  margin: 0;
  padding: 0;
}

.sponsors-list-wrapper .search-hld input#InputSearch {
  background-color: transparent !important;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='11' cy='11' r='8'/><line x1='21' y1='21' x2='16.65' y2='16.65'/></svg>") !important;
  background-repeat: no-repeat !important;
  background-position: 12px center !important;
  border: none !important;
  border-radius: 0 !important;
  color: #ffffff !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  height: 38px !important;
  width: 100% !important;
  padding: 0 16px 0 38px !important;
  box-shadow: none !important;
  outline: none;
}

.sponsors-list-wrapper .search-hld input#InputSearch:focus {
  outline: none !important;
  box-shadow: none !important;
}

.sponsors-list-wrapper .search-hld input#InputSearch::placeholder {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  font-size: 14px;
}

/* Mobile fallback — keep stacked but rounded each control */
@media (max-width: 767.98px) {
  .sponsors-list-wrapper .filter-hld select#selFilter,
  .sponsors-list-wrapper .search-hld input#InputSearch {
    background-color: rgba(0, 0, 0, 0.55) !important;
    border-radius: 999px !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
  }
}
</style>
